import { render, staticRenderFns } from "./merge_video_list.vue?vue&type=template&id=5364a8aa"
import script from "./merge_video_list.vue?vue&type=script&lang=js"
export * from "./merge_video_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports